import { useEffect } from 'react';
const PIXEL_ID = '1983468549040948';
const initializedPixels = new Set<string>();
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
type MetaPixelWindow = Window & {
  _fbq?: MetaPixelFunction;
  fbq?: MetaPixelFunction;
};
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const pixelWindow = window as MetaPixelWindow;
    if (!pixelWindow.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue.push(args);
        }
      } as MetaPixelFunction;
      fbq.queue = [];
      fbq.push = (...args: unknown[]) => fbq.queue.push(args);
      fbq.loaded = true;
      fbq.version = '2.0';
      pixelWindow.fbq = fbq;
      pixelWindow._fbq = fbq;
      if (!document.querySelector('script[data-meta-pixel="true"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        script.dataset.metaPixel = 'true';
        (document.head ?? document.documentElement).appendChild(script);
      }
    }
    const fbq = pixelWindow.fbq;
    if (fbq && !initializedPixels.has(PIXEL_ID)) {
      fbq('init', PIXEL_ID);
      fbq('track', 'PageView');
      initializedPixels.add(PIXEL_ID);
    }
  }, []);
  return <noscript data-id="element-158" data-mp="1mehvyn9y5qvx">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-159" data-mp="1mezwvx7k0ta6" />
    </noscript>;
}